import { addDoc, collection } from "firebase/firestore";
import { db } from "firebaseApp";
import { COLLECTIONS } from "firebaseCollections";
import { botActions } from "store/bot";
import { popupActions } from "store/react-lib/generic-ui/popup";

export async function createConversation(botId, uid, dispatch) {
  try {
    const conversationData = {
      botId,
      uid,
      createdAt: new Date().getTime(),
      subject: "New conversation",
      isDefault: false,
    };
    const conversationRef = await addDoc(
      collection(db, COLLECTIONS.conversations),
      conversationData,
    );
    const conversation = {
      id: conversationRef.id,
        ...conversationData,
    };
    dispatch(
      botActions.setActiveConversation(conversation)
    );
    return conversation;
  } catch(error) {
    console.log(error);
    dispatch(
      popupActions.showError("Failed to create conversation. Try again later")
    );
  }
}